export default __webpack_public_path__ + "static/media/icon-tab-mobile.a1bf5676.svg";